import { HomeData, HomeDetails } from '@/types/homes'
import Paths from '@/config/paths'
import { SEOProps } from '@/types/seo'
import { homeAddressStr } from '@/helpers/homes'

const path = Paths.Home9115tudorE106.loc

export const data: HomeData = {
  mlNumber: "TB8428025",
  status: "Pending",
  address: "9115 TUDOR DR #E106",
  city: "Tampa",
  zip: "33615",
  legalSubdivisionName: "TUDOR CAY CONDOMINIUM BUILDING E UNIT 106 TYPE A .2725 PERCENTAGE OF OWNERSHIP IN COMMON ELEMENTS",
  subdivisionCondoName: "TUDOR CAY CONDO",
  heatedArea: "760",
  currentPrice: "$110,000",
  beds: 1,
  fullBaths: 1,
  halfBaths: 0,
  yearBuilt: 1980,
  pool: "Community",
  propertyStyle: "Condominium",
  tax: "1120",
  cdom: 81,
  adom: 81,
  daysToContract: null,
  soldTerms: null,
  closeDate: null,
  lpPerSqFt: "144.74",
  spPerSqFt: "144.74",
  spPerLp: null,
  listOffice: "",          // Not provided
  listAgent: "Edith Austin",
  listAgentId: "",         // Not provided
  sellingOfficeId: null,
  lscListSide: "",         // Not provided
  listOfficePrimaryBoardId: ""
}

export const details: HomeDetails = {
  path,
  sellingPoint:
    "Start your day with peaceful canal views from your private screened lanai in this beautifully renovated 1-bedroom condo at Tudor Cay. Featuring all-new stainless steel appliances, updated kitchen and bath, fresh paint, new flooring, and generous closet space, this move-in-ready home offers a bright and modern living experience. Enjoy resort-style amenities including two pools, tennis, basketball, handball, racquetball, boat parking, a fishing dock, clubhouse, and on-site laundry — all just minutes from Tampa International Airport, beaches, dining, and shopping.",
  thumbnailImgStr: '/images/homes/thumbnail/9115-tudor-e106-tn.jpg',
  info: 'Check out this home today, call me to schedule a viewing (805) 765-1625',
}

export const seo: SEOProps = {
  title: `View home ${homeAddressStr(data)}`,
  description:
    "Renovated 1BR waterfront condo in Tampa’s Tudor Cay with screened lanai, canal views, new appliances, updated interiors, and resort-style amenities — minutes from TPA and Gulf beaches.",
  type: 'article',
  pagePath: path
}
